import { Action } from "@/api-schema-enums";
import { Can, useAbility } from "@/casl-provider";
import { createRowNavigatePath } from "@/components/data-table/_helpers/create-row-navigate-path";
import { OccupationTable } from "@/components/data-table/predefined/occupation-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";

const DEFAULT_PAGE_SIZE = 100;

export function OccupationView() {
  const { t } = useTranslation(["common", "ram"]);
  const ability = useAbility();
  const canManage = ability.can(Action.Manage, "Occupation");
  const defaultRowActions = canManage
    ? undefined
    : {
        showEdit: false,
        showDelete: false,
        showRestore: false,
      };

  return (
    <Can I="read" a="Occupation">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("ram:Occupations")}
        subTitle={t("common:SearchFilterAndManageEntriesDescription")}
      >
        <OccupationTable
          pageSize={DEFAULT_PAGE_SIZE}
          showCreateButton={canManage}
          defaultRowActions={defaultRowActions}
          onRowNavigate={createRowNavigatePath("/masterdata/occupation")}
        />
      </CenteredLayout>
    </Can>
  );
}
